import { cn } from "@/lib/utils";
import type { ResearchStat } from "@/hooks/useResearchStats";

interface Props {
  stat: ResearchStat;
  size?: "hero" | "standard" | "inline";
  className?: string;
}

export function StatBlock({ stat, size = "standard", className }: Props) {
  const valueClass =
    size === "hero"
      ? "text-6xl md:text-7xl"
      : size === "inline"
      ? "text-3xl"
      : "text-5xl";

  return (
    <article
      className={cn(
        "flex flex-col gap-3 rounded-lg border border-border bg-card p-6 transition-shadow hover:shadow-md",
        className,
      )}
    >
      <div className={cn("font-bold leading-none text-primary", valueClass)}>
        {stat.value_display}
      </div>
      <h3 className="text-lg font-semibold text-foreground">{stat.headline}</h3>
      {stat.description && (
        <p className="text-sm text-muted-foreground">{stat.description}</p>
      )}
      <footer className="mt-auto pt-2 text-xs text-muted-foreground">
        Source:{" "}
        {stat.source_url ? (
          <a
            href={stat.source_url}
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-accent"
          >
            {stat.source_label}
          </a>
        ) : (
          <span>{stat.source_label}</span>
        )}
      </footer>
    </article>
  );
}